module.exports = __webpack_public_path__ + "static/media/box-cancelado.2711761d.jpg";